import { useCallback } from "react";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";
import { errorHandling } from "src/shared/services/errorHandling";
import { exportOrder } from "src/shared/services/services";

interface ExportParams {
  type: string;
  search: string;
  pageNumber: number;
  pageSize: number;
  startDate: string;
  endDate: string;
  OrderStatus: string;
}

const useExportOrder = () => {
  const handleExport = useCallback(async ({ type, search, pageNumber, pageSize, startDate, endDate, OrderStatus }: ExportParams) => {
    notifyLoading("Exporting orders...");
    try {
      const response = await exportOrder(type, search, pageNumber, pageSize, startDate, endDate, OrderStatus);
      closeLoading();
      notifySuccess(response.data.message || "Export successful.");
      return response;
    } catch (error) {
      closeLoading();
      errorHandling(error);
    }
  }, []);

  return { handleExport };
};

export default useExportOrder;
